import React from 'react';
import TopicsAgentPage from '../components/TopicsAgentPage';
import { API_ENDPOINTS } from '../config/api';
import { loadProductTopicGroups } from '../data/productArticleTopics';

const CKAAArticlesAgentPage: React.FC = () => (
  <TopicsAgentPage
    pageTitle="CKAA Articles Agent"
    pageDescription="Generate Crab, Kelp & Amino Acids articles focused on microbes, slow-release fertility, salt-free nutrition, chitin, kelp hormones, amino acids, and clean-input education."
    storageKeyPrefix="ckaa_articles_agent"
    generateAsyncUrl={API_ENDPOINTS.ckaaArticlesGenerateAsync}
    getJobStatusUrl={API_ENDPOINTS.ckaaArticlesJobStatus}
    loadGroups={() =>
      loadProductTopicGroups({
        path: '/keywords/ckaa_blogs - Crab, Kelp & Amino Acids.csv',
        prefix: 'ckaa',
      })
    }
  />
);

export default CKAAArticlesAgentPage;
